export const USE_ELECTRIC_LOG = {
  from: 'src/hooks/useElectric',
  name: 'Connects to Electric',
  message: 'Makes a connection to Electric',
}

export const REFRESH_KEYCLOAK_TOKEN_LOG = {
  from: 'src/hooks/useElectric',
  name: 'Refreshes keycloak token',
  message: "Calls the keycloak function that refreshes token if it's about to expire",
}

export const ELECTRIC_URLS = {
  production: 'https://electric-proxy.insights.winnin.com/v1/shape',
  staging: 'https://electric-proxy-staging.insights.winnin.com/v1/shape',
  local: 'https://electric-proxy.dev.insights.winnin.com/v1/shape',
  development: 'https://electric-proxy.dev.insights.winnin.com/v1/shape',
  test: 'https://electric-proxy.dev.insights.winnin.com/v1/shape',
}
